import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

export const freeTrialValidateSmsKey = "/free_trial/validate_sms";

export const freeTrialValidateSmsCacheKeys: AllRouteEndpoints[] = [freeTrialValidateSmsKey];
